/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: LGPL-2.1-only
 */

a {
  width: var(--qds-control-large-height);
  height: var(--qds-control-large-height);
  display: flex;
  justify-content: center;
  align-items: center;
}
